import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  headerBox: {
    position: 'relative',
    width: '100%',
    background: theme.background.b1,
    zIndex: 2,

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      padding: '16px',
    },
  },
  header: {
    background: theme.background.b1,
    padding: '20px 0',

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      padding: 0,
    },
  },
  inner: {
    gap: 32,
    ...dFlex('initial', 'center'),

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      width: '100%',
    },
  },
  nav: {
    ...dFlex('initial', 'initial'),
    gap: 24,

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      gap: 16,
    },
  },
  navMob: {
    ...dFlex('initial', 'flex-start'),
    flexDirection: 'column',
  },
  activeNavLink: {
    color: theme.primary.p3,

    arrow: {
      path: {
        stroke: theme.primary.p3,
      },
    },
  },
  arrow: {
    height: 24,
    width: 24,
  },
  logo: {
    height: 40,
    marginTop: -15,
  },
  chainButton: {
    [theme.breakpoints.down(Breakpoint.Lg)]: {
      width: '100%',
    },
  },
  row: {
    ...dFlex('space-between', 'center'),

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      display: 'none',
    },
  },
  sideBar: {
    [theme.breakpoints.down(Breakpoint.Lg)]: {
      ...dFlex('initial', 'initial'),
      flexDirection: 'column',
      padding: '0 !important',
      margin: '0 !important',
      width: '100% !important',
      minWidth: 'auto !important',
    },

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      minWidth: 'auto !important',
    },
  },
  buttonWrap: {
    ...dFlex('initial', 'center'),
    gap: 16,

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      flexDirection: 'column',
      marginTop: 24,
      width: '100%',
    },
  },
  myWallet: {
    [theme.breakpoints.down(Breakpoint.Lg)]: {
      width: '100%',
    },
  },
  linkButton: {
    width: '100%',
  },
  connectWallet: {
    [theme.breakpoints.down(Breakpoint.Lg)]: {
      width: '100%',
    },
  },
  headerMob: {
    ...dFlex('space-between', 'center'),
  },
  wrapSideBar: {
    '& .MuiDrawer-paper': {
      background: theme.background.b1,
      overflow: 'scroll',

      [theme.breakpoints.down(Breakpoint.Lg)]: {
        padding: '16px 16px 24px',
        boxSizing: 'border-box',
        width: '100%',
      },
    },
  },
  link: {
    ...dFlex('initial', 'center'),
  },
  navLink: {
    ...dFlex('center', 'center'),
    gap: 4,
    cursor: 'pointer',

    '&:disabled': {
      opacity: '0.5',
      pointerEvents: 'none',
    },
  },
  desktop: {
    marginBottom: -20,
    marginTop: -20,
  },
}));

export default useStyles;
